import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CleanPowerIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 25" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M14.1 1A2 2 0 0 0 12 2.2L9.7 7a3 3 0 0 0-.2 1.8l-7.2 3a2 2 0 0 0-1.2 2.6l.3 1.1A2 2 0 0 0 3.6 17l5.4-.5-.8 6.5H1a1 1 0 1 0 0 2h22a1 1 0 0 0 0-2h-7.6l-1-4.5 2.4 1.9c.8.7 2 .6 2.8-.2l.8-.9a2 2 0 0 0 .2-2.5l-3.2-4.4a3 3 0 0 0-1.4-1l.9-7.8c.2-1-.5-2-1.6-2.3L14.1 1Zm-4 22h3.3L12 16.7v-.1l-1-.8v.3L10 23Zm4-12 .8-7.6v-.1L13.7 3l-2.2 5v.5l.7 2 1.9.4ZM13 12.6l-.2.4-.8 1 6 4.7h.1l.8-.8-3.1-4.4a1 1 0 0 0-.5-.4l-2.3-.5ZM3 13.8l7.1-3 .5 1c0 .2.1.4.3.5l-1.7 2a1 1 0 0 1-.5.2l-5.3.5-.4-1Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default CleanPowerIcon;
